// src/Configurations/s3BaseFolder.js
export default function getBaseFolder() {
  const host = window.location.hostname;
  console.log("S3 path host:", host);

  switch (host) {
    case "www.uat.bms.rcshealth.io":
    case "uat.bms.rcshealth.io":
      // case "localhost":
      return "LandingPage";

    case "www.dev.bms.rcshealth.io":
    case "dev.bms.rcshealth.io":
      case "localhost":
      return "LandingPage";

    case "www.bms.rcshealth.io":
    case "bms.rcshealth.io":
    // case "localhost":
      return "LandingPage";

    default:
      return "LandingPage";
  }
}
